import { PortalConfiguration, PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { getDefaultPortalConfigurationByType } from 'services/pcwService';

export function usePortalConfigurationMergeSavedWithDefault() {
  const mergeSavedPortalConfigWithDefault = (
    savedConfig: PortalConfiguration,
    configType: PortalConfigurationType,
    vendorProfileId: string
  ) => {
    const defaultPortalConfiguration = getDefaultPortalConfigurationByType(configType, vendorProfileId);
    return {
      ...savedConfig,
      jsonDefinition: {
        ...savedConfig.jsonDefinition,
        config: {
          ...defaultPortalConfiguration.jsonDefinition!.config,
          ...savedConfig.jsonDefinition.config,
        },
      },
    };
  };

  const mergeWithDefaultConfigHandlers: {
    [key in PortalConfigurationType]?: (
      savedConfig: PortalConfiguration,
      configType: PortalConfigurationType,
      vendorProfileId: string
    ) => PortalConfiguration;
  } = {
    [PortalConfigurationType.PrescreenManagement]: mergeSavedPortalConfigWithDefault,
    [PortalConfigurationType.VoManagement]: mergeSavedPortalConfigWithDefault,
  };

  const mergeSavedConfigWithDefault = (savedConfig: PortalConfiguration, vendorProfileId: string) => {
    const configType = savedConfig.type!;

    return mergeWithDefaultConfigHandlers[configType]
      ? mergeWithDefaultConfigHandlers[configType](savedConfig, configType, vendorProfileId)
      : savedConfig;
  };

  return {
    mergeSavedConfigWithDefault,
  };
}
